import React from 'react'
import TitleDesc from './MaintitleDesc'
import LinkBlock from './LinkBlock'
export default function LinkBlockComponent(props) {

    return (
        <>
            <TitleDesc {...props} />
            {props.link?
            <LinkBlock multipleLink={props.link} />:null}
        </>
    )
}
